import BaseModelAPI from '../BaseModelAPI';

export default class AppliedTo extends BaseModelAPI {
	static entity = 'appliedto';
	static entityName = 'appliedto';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}